import { useEffect } from "react"
import { create } from "zustand"
import type { BeamState } from "./ds/Beam"

/**
 * What the top-bar beam is doing (motion.md): idle at rest, listening while the
 * reader types or uploads, working during a run, done when the answer lands
 * (settling to its lean), reading while the reader scrolls the answer.
 */
interface BeamStore {
  state: BeamState
  /** Degrees the bar rests at; the answer's lean once there is one. */
  lean: number
  set: (state: BeamState) => void
  setLean: (deg: number) => void
}

export const REST = -10

export const useBeamStore = create<BeamStore>((set) => ({
  state: "idle",
  lean: REST,
  set: (state) => set({ state }),
  setLean: (lean) => set({ lean }),
}))

export function useBeam() {
  const state = useBeamStore((s) => s.state)
  const lean = useBeamStore((s) => s.lean)
  return { state, lean }
}

/** Degrees for a lean: helps tilts the right end up, hurts down, mixed sits level. */
export const leanDegrees = (toward: "helps" | "hurts" | "mixed" | undefined | null) =>
  toward === "helps" ? -8 : toward === "hurts" ? 8 : toward === "mixed" ? 0 : REST

/** Put the beam in `state` while `when` holds; back to idle when the page leaves. */
export function useBeamWhile(state: BeamState, when: boolean) {
  useEffect(() => {
    if (!when) return
    useBeamStore.getState().set(state)
    return () => useBeamStore.getState().set("idle")
  }, [state, when])
}
